export default function MotoStuntsIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="12" fill="#5cc8ff" />
      <path d="M0 52h22l18-14h24v26H0z" fill="#a8743f" />
      <path d="M0 52h22l18-14h24" stroke="#4caf50" strokeWidth="4" fill="none" />
      <g transform="rotate(-24 32 28)">
        <circle cx="20" cy="34" r="7" fill="#1b1b1b" />
        <circle cx="20" cy="34" r="3" fill="#c9ced6" />
        <circle cx="44" cy="34" r="7" fill="#1b1b1b" />
        <circle cx="44" cy="34" r="3" fill="#c9ced6" />
        <path d="M22 28l8-5h12l4 5-6 2H26z" fill="#14b8a6" />
        <path d="M30 23l2-9" stroke="#ff8a1f" strokeWidth="5" strokeLinecap="round" />
        <path d="M33 17l8 6" stroke="#ff8a1f" strokeWidth="3" strokeLinecap="round" />
        <circle cx="33" cy="11" r="5" fill="#ffd84d" stroke="#7b4fd6" strokeWidth="2" />
      </g>
      <path d="M50 10a8 8 0 1 1-8 8" stroke="#ffd84d" strokeWidth="3" fill="none" strokeLinecap="round" />
      <path d="M42 14l0 5 5-1" stroke="#ffd84d" strokeWidth="3" fill="none" strokeLinecap="round" />
    </svg>
  );
}
